import {Alert} from "@/components/alert/Alert.tsx";
import {SupportLink} from "@/components/formSubtext/subComponents/SupportLink/SupportLink.tsx";

interface RUMNeedHelpProps {
  link?: string;
}

export const RUMNeedHelp = ({link}: RUMNeedHelpProps) => {
  link = link || "https://support.uptime.com/hc/en-us/articles/4415874052242-RUM-Advanced-Data-and-Reports#check_page";

  return (
    <Alert dismissible callout={"Need help?"}>
      <span>Hover over items for on-screen tooltips or view documentation</span>
      <SupportLink className="ms-2" href={link} text="View support article" />
    </Alert>
  );
};
